import { notification } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { UserStories } from './user-stories';

export function UserStoriesRoute(): JSX.Element {
	const [showError, setShowError] = useState<boolean>(false);

	useEffect(() => {
		if (showError === true) {
			notification.error({ message: 'Netværks fejl', onClose: () => setShowError(false) });
		}
	}, [showError]);

	return (
		<Container className="dashboard-container">
			<UserStories handleShowError={() => setShowError(true)} />
		</Container>
	);
}

const Container = styled.main`
	background-color: #1A202C;
	justify-content: center;
	align-items: center;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
	
	.carousel-container {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		gap: 4rem;
		margin: 4rem;
	}
	
	.carousel-img-reload {
		height: 350px;
		width: 350px;
		border-radius: 50%;
		object-fit: cover;
	}
	
	.carousel-img-container {
		align-self: center;
		padding: 12px;
		border: 5px solid #6675CD;
		border-radius: 50%;
	}
	
	.carousel-text-container {
		width: 1300px;
		background-color: #1F2937;
		padding: 4em;
		border-radius: 6px;
	}
	
	.carousel-titel {
		font-size: 2em;
		line-height: 2.2em;
		
		h1 { 
			color: #FFFFFF; 
			font-weight: 700;
		
		}
		.username {
			color: #6675CD;
			font-weight: 700
		}
	}

	.carousel-text {
		font-size: 2.4em;
		color: #9CA3AF;
	}
`;
